import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Collapse,
  Button,
  Select,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";

import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar'
import CheckIcon from '@mui/icons-material/Check';
import MuiAlert from '@mui/material/Alert';



import {useLocation } from "react-router-dom";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';
import Overlayy from "../../layouts/FullLayout/Overlay/Overlayy";
import config from "../../config.js";
import useVariant from "antd/es/form/hooks/useVariants";

const ComplaintsTable = ({selectedValue,onRowClick}) => { 

  const userId=localStorage.getItem('userId');
  const designation=localStorage.getItem('designation');
  const department=localStorage.getItem('department');
  const department_id = localStorage.getItem('department_id');
  const emailId = localStorage.getItem('email');
  //for remainder notifaction for technician
  const today = new Date()
  const location = useLocation();
  const [mainData, setMainData] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [openRows, setOpenRows] = useState({});
  const [approvalStatus, setApprovalStatus] = useState({});
  const [selected,setSelectedValue] = useState({});
  const [table3Data,setUserDetails] = useState([]);
  const [etcValues, setEtcValues] = useState({});
  const [message, setMessage] = useState('');
  const [satisfactionpoints, setSatisfactionpoints] = useState('');
  const [isSending, setIsSending] = useState(false); 
  const [isSent, setIsSent] = useState({});  // Track sent status for each complaint ID
  const [isSentSatisfactorypoints, setIsSentSatisfactorypoints] = useState({});
  // alert system
  const [alert, setAlert] = useState({ open: false, message: '', severity:'success' , variant:'filled' });

  //for HOD approval comments
  const[openHOD,setOpenHOD] = useState(false);
  const [approvalComments, setApprovalComments] = useState('');
  
  //for rejection summary
  const [open, setOpen] = useState(false);
  const [openAO, setOpenAO] = useState(false);
  const [opend, setOpend] = useState(false); //for director
  const [selectedComplaintId, setSelectedComplaintId] = useState(null);
  const [selectedComplainerId, setSelectedComplainerId] = useState(null);
  const [rejectionSummary, setRejectionSummary] = useState('');
  const[email_id,setEmail_id] = useState('');
  
  //for comletion summary
  const [openc, setOpenc] = useState(false);// for completion summary technician
  const [opencs, setOpencs] = useState(false);// for completion summary supervisor
  const [completionSummary, setCompletionSummary] = useState('');

  //for the modal which is used in rejection summary
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    borderRadius: '10px',
    p: 3,
};
  console.log(userId);

  const ETCOptions = {
    Oneday: "Mentioned work will be completed in 1 day",
    Sevendays: "Mentioned work will be completed in 7 days",
    Tendays: "Mentioned work will be completed in 10 days",
    Fifteendays: "Mentioned work will be completed in 15 days",
    Thirtydays: "Mentioned work will be completed in 30 days"
  };

  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };
  
  const getInProgressComplaints = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/Inprogresscomplaints/${userId}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setMainData(jsonData);
      setCombinedData(jsonData);
  }
    catch(err){
      console.error(err.message);
    }
  }

  const getCompletedComplaints = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/Completedcomplaints/${userId}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
  }
    catch(err){ 
      console.error(err.message);
    }
  }

  const getPendingComplaintsComplainer = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/Pendingcomplaints/${userId}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
  }
    catch(err){ 
      console.error(err.message);
    }
  }

  // const getUnderProcurementComplaintsComplainer = async () => {
  //   try{
  //       const response = await fetch(`${config.BASE_URL_IP}/wob/underprocurementcomplaintscomplainer/${userId}`, {
  //       method: "GET", 
  //       headers: { "Content-Type": "application/json"},
        
  //     })
  //     const jsonData = await response.json();
  //     console.log(jsonData);
  //     jsonData.sort((a, b) => {
  //       let da = new Date(a.complaint_raise_date),
  //           db = new Date(b.complaint_raise_date);
  //       return db - da;
  //     });
  //     setCombinedData(jsonData);
  // }
  //   catch(err){ 
  //     console.error(err.message);
  //   }
  // }

  const getRejectedComplaintsComplainer = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/rejectedcomplaintscomplainer/${userId}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
  }
    catch(err){ 
      console.error(err.message);
    }
  }

  const getRejectedComplaintsHod = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/rejectedcomplaintshod/${department}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        initialApprovalStatus[complaint.complaint_id] = complaint.approved_by_director_date
          ? "Approved"
          : complaint.work_status === "Rejected By Director"
          ? "Rejected"
          : complaint.work_status === "Pending"
          ? "Pending-Justification needed"
          : complaint.work_status === "Pending-justification given"
          ? "Pending-justification given"
          : "Awaits Justification";
      });
      setApprovalStatus(initialApprovalStatus);
      
  }
    catch(err){
      console.error(err.message);
    }
  };

  const getRejectedComplaintsDirector = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/rejectedcomplaintsdirector`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        initialApprovalStatus[complaint.complaint_id] = complaint.approved_by_director_date
          ? "Approved"
          : complaint.work_status === "Rejected By Director"
          ? "Rejected"
          : complaint.work_status === "Pending"
          ? "Pending-Justification needed"
          : complaint.work_status === "Pending-justification given"
          ? "Pending-justification given"
          : "Awaits Justification";
      });
      setApprovalStatus(initialApprovalStatus);
      
  }
    catch(err){
      console.error(err.message);
    }
  };

  const getRejectedComplaintsAOOfficer = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/rejectedcomplaintsaoofficer`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        initialApprovalStatus[complaint.complaint_id] = complaint.approved_by_ao_date
          ? "Approved"
          : complaint.work_status === "Rejected By Director"
          ? "Rejected"
          : complaint.work_status === "Pending"
          ? "Pending-Justification needed"
          : complaint.work_status === "Pending-justification given"
          ? "Pending-justification given"
          : "Awaits Justification";
      });
      setApprovalStatus(initialApprovalStatus);
      
  }
    catch(err){
      console.error(err.message);
    }
  };

  const getInProgressComplaintshod = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/inprogresscomplaintshod/${department}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
      setMainData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        initialApprovalStatus[complaint.complaint_id] = complaint.approved_by_hod_date
          ? "Approved"
          : complaint.work_status === "Rejected By HOD"
          ? "Rejected"
          : complaint.work_status === "Pending"
          ? "Pending-Justification needed"
          : complaint.work_status === "Pending-justification given"
          ? "Pending-justification given"
          : "Awaits Justification";
      });
      setApprovalStatus(initialApprovalStatus);
      
  }
    catch(err){
      console.error(err.message);
    }
  }

  const getCompletedComplaintshod = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/CompletedComplaintshod/${department}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
  }
    catch(err){
      console.error(err.message);
    }
  }
  const getInProgressComplaintsDirector = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/AO-approved-Inprogresscomplaints`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
      setMainData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        initialApprovalStatus[complaint.complaint_id] = complaint.approved_by_director_date
          ? "Approved"
          : complaint.work_status === "Rejected By Director"
          ? "Rejected"
          : complaint.work_status === "Pending"
          ? "Pending-Justification needed"
          : complaint.work_status === "Pending-justification given"
          ? "Pending-justification given"
          : "Awaits Justification";
      });
      setApprovalStatus(initialApprovalStatus);
      
  }
    catch(err){
      console.error(err.message);
    }
  }

  const getInProgressComplaintsAOOfficer = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/inprogresscomplaintsaoofficer`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
      setMainData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        initialApprovalStatus[complaint.complaint_id] = complaint.approved_by_ao_date
          ? "Approved"
          : complaint.work_status === "Rejected By AO"
          ? "Rejected"
          : complaint.work_status === "Pending"
          ? "Pending-Justification needed"
          : complaint.work_status === "Pending-justification given"
          ? "Pending-justification given"
          : "Awaits Justification";
      });
      setApprovalStatus(initialApprovalStatus);
      
  }
    catch(err){
      console.error(err.message);
    }
  }

  const getPendingComplaintsDirector = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/Pendingcomplaints-Director`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        initialApprovalStatus[complaint.complaint_id] = complaint.approved_by_director_date
          ? "Approved"
          : complaint.work_status === "Rejected By Director"
          ? "Rejected"
          : complaint.work_status === "Pending"
          ? "Pending-Justification needed"
          : complaint.work_status === "Pending-justification given"
          ? "Pending-justification given"
          : "Awaits Justification";
      });
      setApprovalStatus(initialApprovalStatus);
  }
    catch(err){ 
      console.error(err.message);
    }
  }

  const getCompletedComplaintsDirector = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/HOD-approved-Completedcomplaints`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
  }
    catch(err){
      console.error(err.message);
    }
  }

  // const getUnderProcurementComplaintsHod = async () => {
  //   try{
  //       const response = await fetch(`${config.BASE_URL_IP}/wob/underprocurementcomplaintshod/${department}`, {
  //       method: "GET", 
  //       headers: { "Content-Type": "application/json"},
        
  //     })
  //     const jsonData = await response.json();
  //     console.log(jsonData);
  //     jsonData.sort((a, b) => {
  //       let da = new Date(a.complaint_raise_date),
  //           db = new Date(b.complaint_raise_date);
  //       return db - da;
  //     });
  //     setCombinedData(jsonData);

  //     const initialApprovalStatus = {};
  //     jsonData.forEach(complaint => {
  //       initialApprovalStatus[complaint.complaint_id] = complaint.approved_by_director_date
  //         ? "Approved"
  //         : complaint.work_status === "Rejected By Director"
  //         ? "Rejected"
  //         : complaint.work_status === "Pending"
  //         ? "Pending-Justification needed"
  //         : complaint.work_status === "Pending-justification given"
  //         ? "Pending-justification given"
  //         : "Awaits Justification";
  //     });
  //     setApprovalStatus(initialApprovalStatus);
      
  // }
  //   catch(err){
  //     console.error(err.message);
  //   }
  // };

  // const getUnderProcurementComplaintsDirector = async () => {
  //   try{
  //       const response = await fetch(`${config.BASE_URL_IP}/wob/underprocurementcomplaintsdirector`, {
  //       method: "GET", 
  //       headers: { "Content-Type": "application/json"},
        
  //     })
  //     const jsonData = await response.json();
  //     console.log(jsonData);
  //     jsonData.sort((a, b) => {
  //       let da = new Date(a.complaint_raise_date),
  //           db = new Date(b.complaint_raise_date);
  //       return db - da;
  //     });
  //     setCombinedData(jsonData);

  //     const initialApprovalStatus = {};
  //     jsonData.forEach(complaint => {
  //       initialApprovalStatus[complaint.complaint_id] = complaint.approved_by_director_date
  //         ? "Approved"
  //         : complaint.work_status === "Rejected By Director"
  //         ? "Rejected"
  //         : complaint.work_status === "Pending"
  //         ? "Pending-Justification needed"
  //         : complaint.work_status === "Pending-justification given"
  //         ? "Pending-justification given"
  //         : "Awaits Justification";
  //     });
  //     setApprovalStatus(initialApprovalStatus);
      
  // }
  //   catch(err){
  //     console.error(err.message);
  //   }
  // };


  const getUserDetails = async () => {
    try {
      const response = await fetch(`${config.BASE_URL_IP}/wob/user`,{
      method : "GET",
      headers : {'Content-Type' : "application/json"}
    })
    const jsonData = await response.json()
    setUserDetails(jsonData);

    } catch (err) {
      console.error(err.message);
    }
  }

  

  const getInProgressComplaintsSupervisor = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/Director-approved-Inprogresscomplaints/${department}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
      setMainData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        initialApprovalStatus[complaint.complaint_id] = complaint.work_assigned_date
          ? "Approved"
          : complaint.work_status === "Rejected"
          ? "Rejected"
          : "Pending";
      });
      setApprovalStatus(initialApprovalStatus); 
  }
    catch(err){
      console.error(err.message);
    }
  }

  const getCompletedComplaintsSupervisor = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/completedcomplaintssupervisor/${department}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
  }
    catch(err){
      console.error(err.message);
    }
  }

  const getInProgressComplaintstechnician = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/inprogresscomplaintstechnician/${userId}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
      setMainData(jsonData);

      const ETC = {};
      jsonData.forEach(complaint => {
        ETC[complaint.complaint_id] = complaint.expected_completion_date ? new Date(complaint.expected_completion_date).toLocaleDateString() : undefined;
      });
      setEtcValues(ETC);
  
    }
    catch(err){
      console.error(err.message);
    }
  }

  const getCompletedComplaintstechnician = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/completedcomplaintstechnician/${userId}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);
    }
    catch(err){
      console.error(err.message);
    }
  }

  const getUnderProcurementComplaintsTechnician = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/underprocurementcomplaintstechnician/${userId}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        if(complaint.work_status === 'Closed-technician' || complaint.work_status === 'Closed')
        {
          initialApprovalStatus[complaint.complaint_id] = 'Closed';
          setApprovalStatus(initialApprovalStatus);
        }
      });
    }
    catch(err){
      console.error(err.message);
    }
  }

  const getClosedByTechnicianComplaintsTechnician = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/closedbytechniciancomplaintstechnician/${userId}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        if(complaint.work_status === 'Closed-technician' || complaint.work_status === 'Closed')
        {
          initialApprovalStatus[complaint.complaint_id] = 'Closed';
          setApprovalStatus(initialApprovalStatus);
        }
      });
    }
    catch(err){
      console.error(err.message);
    }
  }

  const getUnderProcurementComplaintsSupervisor = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/underprocurementcomplaintssupervisor/${department}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        if(complaint.work_status === 'Closed-Technician')
        {
          initialApprovalStatus[complaint.complaint_id] = 'Closed-technician';
          setApprovalStatus(initialApprovalStatus);
        }
      });
    }
    catch(err){
      console.error(err.message);
    }
  }

  const getToBeClosedComplaintsSupervisor = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/tobeclosedcomplaintssupervisor/${department}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      jsonData.sort((a, b) => {
        let da = new Date(a.complaint_raise_date),
            db = new Date(b.complaint_raise_date);
        return db - da;
      });
      setCombinedData(jsonData);

      const initialApprovalStatus = {};
      jsonData.forEach(complaint => {
        if(complaint.work_status === 'Closed-Technician')
        {
          initialApprovalStatus[complaint.complaint_id] = 'Closed-technician';
          setApprovalStatus(initialApprovalStatus);
        }
      });
    }
    catch(err){
      console.error(err.message);
    }
  }

  const handleCloseAlert = () => {
    setAlert({ ...alert, open: false });
    setTimeout(function(){window.location.reload()}, 3000);
  };
  
   // Function to handle sending the justification responed by complainer
   const handleSend = async (complaintId,complainer_id) => {
    if (message.trim() === '') {
      // window.alert('Please enter a message.'); 
      setAlert({ open: true, message: 'Please enter a message.', severity: 'warning', variant:"filled" });
      return;
    }
    window.location.reload();

    setIsSending(true); // Set sending status to true

    try {
      // Make a POST request to save the message in the database
      await fetch(`${config.BASE_URL_IP}/wob/Justification-given/${complaintId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message }),
      });
      setIsSent((prev) => ({ ...prev, [complaintId]: true }));
      // Optionally, show a success message or perform any other action
      console.log('Message sent successfully!');

      // Make a POST request to save the notification in the database
      const receiverId = 'DIRECTOR';
      await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ complaintId,receiverId, message: `${complainer_id} complainer has responded with a justification for his complaint ${complaintId}` })
    });

    //to give notification as email
    const to = 'director@nitttrc.edu.in'; // director email.
    const subject = 'Justifiaction sent by complainer';
        // to send notification as mail
       await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ to,subject , text:`${complainer_id} complainer has responded with a justification for his complaint ${complaintId}` })
    });

    setAlert({ open: true, message: 'Justifiaction Sent To Director.', severity: 'success', variant:"filled" });

    setTimeout(function(){window.location.reload()}, 2000);
    } catch (error) {
      console.error('Error sending message:', error);
      setIsSending(false);
    }
  };

     // Function to handle sending the message
    const handleSendSatifactorypoints = async (complaintId,complainer_id,technician_id,email_id) => {
    if (satisfactionpoints.trim() === '') {
      setAlert({ open: true, message: 'Please enter a message.', severity: 'warning', variant:"filled" });
      return;
    }

    try {
      // Make a POST request to save the message in the database
      await fetch(`${config.BASE_URL_IP}/wob/Sastisfactorypoints-given/${complaintId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ satisfactionpoints }),
      });
      setIsSentSatisfactorypoints((prev) => ({ ...prev, [complaintId]: true }));
      // Optionally, show a success message or perform any other action
      console.log('Message sent successfully!');

      // Make a POST request to save the notification in the database
      const receiverId = technician_id;
      await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ complaintId,receiverId, message: `${complainer_id} complainer has responded with satisfaction points for your work ${complaintId}` })

    });

      //to give notification as email
      const to = email_id;
      const subject = 'Satisfactory points given by Complainer';
          // to send notification as mail
          await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ to,subject , text:`${complainer_id} complainer has responded with satisfaction points for your work ${complaintId}` })
      });

      setAlert({ open: true, message: 'Satisfaction points added successfully.', severity: 'success', variant:"filled" });

      setTimeout(function(){window.location.reload()}, 2000);
    } catch (error) {
      console.error('Error sending message:', error);
      setIsSending(false);
    }
  };
  
  const handleCancelComplaint = async (complaintId,complainerEmailId) => {
    try {
              // If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
              setApprovalStatus(prevStatus => ({
                  ...prevStatus,
                  [complaintId]: "Cancelled"
              }));
  
              // Update the database
              const response = await fetch(`${config.BASE_URL_IP}/wob/Cancel-complaint/${complaintId}`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
              });

                    //to give notification as email
              const to = complainerEmailId;
              const subject = 'Complaint Cancelled';
                  // to send notification as mail
                  await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ to,subject , text:`your complaint ${complaintId} has been cancelled sucessfully.` })
              });

              console.log(response);
              setAlert({ open: true, message: 'Complaint cancelled.', severity: 'error', variant:'filled' });
              setTimeout(function(){window.location.reload()}, 2000);
  
      } catch (err) {
          console.log(err.message);
      }
  };

  const handleApprovehod = async (complaintId, complainerId, approvalComments, complainerEmailId) => {
  try {
            // If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
            setApprovalStatus(prevStatus => ({
                ...prevStatus,
                [complaintId]: "Approved"
            }));

            // Store notification in local storage for the user who lodged the complaint
            let receiverId = complainerId;

            // Update the database
            const response = await fetch(`${config.BASE_URL_IP}/wob/HOD-approval/${complaintId}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ approvalComments })
            });
            console.log(response);
            setAlert({ open: true, message: 'Complaint Approved Successfully.', severity: 'success', variant:'filled' });

             // Make a POST request to save the notification in the database
             await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ complaintId,receiverId, message: `Your complaint ${complaintId} has been Approved by HOD` })
          });

          const to = complainerEmailId;
          const subject = 'Complaint Approved by HOD';
              // to send notification as mail
             await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ to,subject , text:`Your complaint ${complaintId} has been Approved by HOD` })
          });

           receiverId = 'DIRECTOR';
           await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ complaintId,receiverId, message: `The complaint ${complaintId} has been Approved by HOD. Please review.` })
        });

          const To = 'director@nitttrc.edu.in';
          const Subject = 'Complaint Approved by HOD';
              // to send notification as mail
             await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ To,Subject , text:`The complaint ${complaintId} has been Approved by HOD. Please review.` })
          });
          setTimeout(function(){window.location.reload()}, 2000);

    } catch (err) {
        console.log(err.message);
    }
};

  const handleRejecthod = async (complaintId, complainerId, rejectionSummary,email_id) => {
    if (rejectionSummary.trim() === '') {
      setAlert({ open: true, message: 'Please enter a message.', severity: 'warning', variant:'filled' });
      return;
    }

    try {
        // If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
        setApprovalStatus(prevStatus => ({
            ...prevStatus,
            [complaintId]: "Rejected"
        }));

        const receiverId = complainerId

          // Make a POST request to save the notification in the database
          await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ complaintId,receiverId, message: `Your complaint ${complaintId} has been Rejected by HOD` })
        });
        
        // Update the database
        const response = await fetch(`${config.BASE_URL_IP}/wob/HOD-Rejected/${complaintId}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ rejectionSummary })
        });

        //to give notification as email
        const to = email_id;
        const subject = 'Complaint Rejected By HOD';
            // to send notification as mail
            await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ to,subject , text:`Your complaint ${complaintId} has been Rejected by HOD` })
        });
        console.log(response);
        setAlert({ open: true, message: 'Complaint Rejected Successfully.', severity: 'success', variant:'filled' });
        setTimeout(function(){window.location.reload()}, 2000);
} catch (err) {
    console.log(err.message);
}
  };

  const handleRejectAO = async (complaintId, complainerId, rejectionSummary,email_id) => {
    if (rejectionSummary.trim() === '') {
      setAlert({ open: true, message: 'Please enter a message.', severity: 'warning', variant:'filled' });
      return;
    }

    try {
        // If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
        setApprovalStatus(prevStatus => ({
            ...prevStatus,
            [complaintId]: "Rejected"
        }));

        const receiverId = complainerId

          // Make a POST request to save the notification in the database
          await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ complaintId,receiverId, message: `Your complaint ${complaintId} has been Rejected by AO` })
        });
        
        // Update the database
        const response = await fetch(`${config.BASE_URL_IP}/wob/AO-Rejected/${complaintId}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ rejectionSummary })
        });

        //to give notification as email
        const to = email_id;
        const subject = 'Complaint Rejected By AO';
            // to send notification as mail
            await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ to,subject , text:`Your complaint ${complaintId} has been Rejected by AO` })
        });
        console.log(response);
        setAlert({ open: true, message: 'Complaint Rejected Successfully.', severity: 'success', variant:'filled' });
        setTimeout(function(){window.location.reload()}, 2000);
} catch (err) {
    console.log(err.message);
}
  };

  //function to handle HOD approval with comments
  const handleOpenHOD = (complaintId, complainerId, complainerEmailId) => {
    setSelectedComplaintId(complaintId);
    setSelectedComplainerId(complainerId);
    setEmail_id(complainerEmailId)
    setOpenHOD(true);
};

  //functions to handle rejection with summary - HOD
  const handleOpen = (complaintId, complainerId, complainerEmailId) => {
    setSelectedComplaintId(complaintId);
    setSelectedComplainerId(complainerId);
    setEmail_id(complainerEmailId)
    setOpen(true);
};

const handleOpenAO = (complaintId, complainerId, complainerEmailId) => {
  setSelectedComplaintId(complaintId);
  setSelectedComplainerId(complainerId);
  setEmail_id(complainerEmailId)
  setOpenAO(true);
};

//foor director rejcetion summary
  const handleOpend = (complaintId, complainerId, complainerEmailId) => {
  setSelectedComplaintId(complaintId);
  setSelectedComplainerId(complainerId);
  setEmail_id(complainerEmailId)
  setOpend(true);
};

//completion summary of technician
  const handleOpenc = (complaintId, complainerId, complainerEmailId) => {
    setSelectedComplaintId(complaintId);
    setSelectedComplainerId(complainerId);
    setEmail_id(complainerEmailId);
    setOpenc(true);
  };

//completion summary of Supervisor
  const handleOpencs = (complaintId, complainerId, complainerEmailId, completion_summary) => {
    setSelectedComplaintId(complaintId);
    setSelectedComplainerId(complainerId);
    setEmail_id(complainerEmailId);
    setCompletionSummary(completion_summary);
    setOpencs(true);
  };
  
  //Approval comments for HOD
  const handleCloseHOD = () => {
    setOpenHOD(false)};

  const handleUnderProcurement = async (complaintId, complainer_id) => {
    try {            
          // //If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
          // setApprovalStatus(prevStatus => ({
          //     ...prevStatus,
          //     [complaintId]: "Approved"
          // }));

          const receiverId = complainer_id

          //   Make a POST request to save the notification in the database
            await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ complaintId,receiverId, message: `Your complaint ${complaintId} has been closed because the materials needed are under procurement` })
          });

      //   Update the database
          const response = await fetch(`${config.BASE_URL_IP}/wob/handleunderprocurement/${complaintId}`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
          });

      //to give notification as email
      const to = email_id;
      const subject = 'Complaint Approved By Director';
          // to send notification as mail
          await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ to,subject , text:`Your complaint ${complaintId} has been closed because the materials needed are under procurement` })
      });

          console.log(response);
          setAlert({ open: true, message: 'Complaint closed for procurement Successfully.', severity: 'success', variant:'filled' });
          setTimeout(function(){window.location.reload()}, 2000);
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleReopen = async (complaintId, complainer_id) => {
    try {            
          // //If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
          // setApprovalStatus(prevStatus => ({
          //     ...prevStatus,
          //     [complaintId]: "Approved"
          // }));

          const receiverId = complainer_id

          //   Make a POST request to save the notification in the database
            await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ complaintId,receiverId, message: `Your complaint ${complaintId} has been reopened after required procurement` })
          });

      //   Update the database
          const response = await fetch(`${config.BASE_URL_IP}/wob/handlereopencomplaint/${complaintId}`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
          });

      //to give notification as email
      const to = email_id;
      const subject = 'Complaint Approved By Director';
          // to send notification as mail
          await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ to,subject , text:`Your complaint ${complaintId} has been reopened after required procurement` })
      });

          console.log(response);
          setAlert({ open: true, message: 'Complaint Reopened Successfully.', severity: 'success', variant:'filled' });
          setTimeout(function(){window.location.reload()}, 2000);
    } catch (err) {
      console.log(err.message);
    }
  };


  //rejection summary for HOD
  const handleClose = () => {
    setOpen(false)};
  //rejection summary for Director
  const handleClosed = () => {
      setOpend(false)};
  //Completion summary for Technician  
  const handleClosec = () => {
    setOpenc(false)};
  //Completion summary for supervisor
  const handleClosecs = () => {
      setOpencs(false)};
  
  const handleApproveWithCommentsHOD = async () => {
    // Call the reject function with the rejection summary
    await handleApprovehod(selectedComplaintId, selectedComplainerId, approvalComments,email_id);
    setOpenHOD(false);
  };

  const handleRejectWithSummaryHOD = async () => {
    // Call the reject function with the rejection summary
    await handleRejecthod(selectedComplaintId, selectedComplainerId, rejectionSummary,email_id);
    setOpen(false);
  };

  const handleRejectWithSummaryAO = async () => {
    // Call the reject function with the rejection summary
    await handleRejectAO(selectedComplaintId, selectedComplainerId, rejectionSummary,email_id);
    setOpen(false);
  };

  const handleRejectWithSummaryDirector = async () => {
    // Call the reject function with the rejection summary
    await handleRejectDirector(selectedComplaintId, selectedComplainerId, rejectionSummary,email_id);
    console.log(email_id);
    setOpen(false);
  };

  const handleCompletionSummary = async () => {
    // Call the reject function with the rejection summary
    await handleCloseTechnician(selectedComplaintId, selectedComplainerId, completionSummary, email_id);
    setOpenc(false);
  };

  const handleCompletionSummarysupervisor = async () => {
    // Call the reject function with the rejection summary
    await handleCloseSupervisor(selectedComplaintId, selectedComplainerId, completionSummary, email_id);
    setOpencs(false);
  };


  const handleApproveAO = async (complaintId,complainerId,email_id) => {
    try {            
            //If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
            setApprovalStatus(prevStatus => ({
                ...prevStatus,
                [complaintId]: "Approved"
            }));

            

         //   Update the database
            const response = await fetch(`${config.BASE_URL_IP}/wob/AO-approval/${complaintId}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
            });
          //Store notification in local storage for the user who lodged the complaint
          const receiverId = complainerId

          //   Make a POST request to save the notification in the database
            await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ complaintId,receiverId, message: `Your complaint ${complaintId} has been Approved by AO` })
          });
        //to give notification as email
        const to = email_id;
        const subject = 'Complaint Approved By AO';
            // to send notification as mail
            await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ to,subject , text:`Your complaint ${complaintId} has been Approved by AO.` })
        });

            console.log(response);
            setAlert({ open: true, message: 'Complaint Approved Successfully.', severity: 'success', variant:'filled' });
            setTimeout(function(){window.location.reload()}, 2000);
    } catch (err) {
        console.log(err.message);
    }
  };

  const handleApproveDirector = async (complaintId,complainerId,email_id) => {
    try {            
            //If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
            setApprovalStatus(prevStatus => ({
                ...prevStatus,
                [complaintId]: "Approved"
            }));

            

         //   Update the database
            const response = await fetch(`${config.BASE_URL_IP}/wob/Director-approval/${complaintId}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
            });
          //Store notification in local storage for the user who lodged the complaint
          const receiverId = complainerId

          //   Make a POST request to save the notification in the database
            await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ complaintId,receiverId, message: `Your complaint ${complaintId} has been Approved by Director` })
          });
        //to give notification as email
        const to = email_id;
        const subject = 'Complaint Approved By Director';
            // to send notification as mail
            await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ to,subject , text:`Your complaint ${complaintId} has been Approved by Director.` })
        });

            console.log(response);
            setAlert({ open: true, message: 'Complaint Approved Successfully.', severity: 'success', variant:'filled' });
            setTimeout(function(){window.location.reload()}, 2000);
    } catch (err) {
        console.log(err.message);
    }
  };

  const handleJustificationDirector = async (complaintId,complainerId,email_id) => {
    try {
        // If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
        setApprovalStatus(prevStatus => ({
            ...prevStatus,
            [complaintId]: "Pending-justification given"
        }));

        const receiverId = complainerId

          // Make a POST request to save the notification in the database
          await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ complaintId,receiverId, message: `Your complaint ${complaintId} has been Rejected by Director.Please give proper justification for your complaint` })
        });
        
        // Update the database
        const response = await fetch(`${config.BASE_URL_IP}/wob/Director-justification/${complaintId}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        });

        //to give notification as email
        const to = email_id;
        const subject = 'Give justifiaction for your complaint';
            // to send notification as mail
            await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ to,subject , text:`Your complaint ${complaintId} has been Rejected by Director.Please give proper justification for your complaint` })
        });
        
        console.log(response);
        setAlert({ open: true, message: 'Justification to be given by complianer.', severity: 'warning', variant:'filled' });
        setTimeout(function(){window.location.reload()}, 2000);
      } catch (err) {
          console.log(err.message);
      }
  };

  const handleRejectDirector = async (complaintId,complainerId,rejectionSummary,email_id) => {
    if (rejectionSummary.trim() === '') {
      setAlert({ open: true, message: 'Please enter a message.', severity: 'success', variant:'filled' });// Show alert if the message is empty
      return;
    }

    try {
        // If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
        setApprovalStatus(prevStatus => ({
            ...prevStatus,
            [complaintId]: "Rejected"
        }));

        const receiverId = complainerId

          // Make a POST request to save the notification in the database
          await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ complaintId,receiverId, message: `Your complaint ${complaintId} has been Rejected by Director` })
        });
        
        // Update the database
        const response = await fetch(`${config.BASE_URL_IP}/wob/Director-Rejected/${complaintId}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ rejectionSummary })
        });

        //to give notification as email
        const to = email_id;
        const subject = 'Workorder Rejected By Director';
            // to send notification as mail
            await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ to,subject , text:`Your complaint ${complaintId} has been Rejected by Director. The Rejection summary for your complaint is ${rejectionSummary}` })
        });
                
        console.log(response);
        setAlert({ open: true, message: 'Complaint Rejected Successfully.', severity: 'success', variant:'filled' });
        setTimeout(function(){window.location.reload()}, 2000);
      } catch (err) {
          console.log(err.message);
      }
    console.log(email_id);
  };

  const handleApproveSupervisor = async (complaintId, technician_id, complainerId, email_id, contactNum, technicianMail) => {
    try {
            // If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
            setApprovalStatus(prevStatus => ({
                ...prevStatus,
                [complaintId]: "Approved"
            }));

            // Update the database
            const response = await fetch(`${config.BASE_URL_IP}/wob/Supervisor-approval/${complaintId}/${technician_id}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
            });


            let receiverId = complainerId;

            // Make a POST request to save the notification in the database
            await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ complaintId, receiverId, message: `Your complaint ${complaintId} has been Assigned to technician ${technician_id}` })
          });

          // Make a POST request to save the notification in the database
          receiverId = technician_id;
          await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ complaintId, receiverId, message: `The complaint ${complaintId} has been Assigned to you. The contact details of the complainer are: ${contactNum}` })
        });
            
          //to give notification as email
          const to = email_id;
          const subject = 'Work assigned to Technician';
              // to send notification as mail
              await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ to, subject, text:`Your complaint ${complaintId} has been Assigned to technician ${technician_id}` })
          });

          const technicianMailSend = 'New work assigned';
              // to send notification as mail
              await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ technicianMail, technicianMailSend, text:`The complaint ${complaintId} has been Assigned to you. The contact details of the complainer are: ${contactNum}` })
          });
                      
            console.log(response);
            setAlert({ open: true, message: 'Technician assigned Successfully.', severity: 'success', variant:'filled' });
            setTimeout(function(){window.location.reload()}, 2000);
    } catch (err) {
        console.log(err.message);
    }
  };

  const handleApproveSupervisorCompletionsummary = async (complaintId,complainerId,email_id) => {
    try {
            // If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
            setApprovalStatus(prevStatus => ({
                ...prevStatus,
                [complaintId]: "Approved"
            }));

            const receiverId = complainerId

            // Update the database
            const response = await fetch(`${config.BASE_URL_IP}/wob/Supervisor-approvecompletionsummary/${complaintId}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
            });

            // Make a POST request to save the notification in the database
            await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ complaintId,receiverId, message: `Your complaint ${complaintId}'s completion has been reviewed and approved by incharge. complaint officially closed` })
          });

          //to give notification as email
          const to = email_id;// to technician
          const subject = 'Completetion summary reviwed and approved by incharge.';
              // to send notification as mail
              await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ to,subject , text:`Your complaint ${complaintId}'s completion has been reviewed and approved by incharge. complaint officially closed` })
          });

            console.log(response);
            setAlert({ open: true, message: 'Complaint Summary Approved Successfully.', severity: 'success', variant:'filled' });
            setTimeout(function(){window.location.reload()}, 2000);
    } catch (err) {
        console.log(err.message);
    }
  };

  const handleETCChange = async (complainerId, complaintId, etcValue, email_id) => {
    setEtcValues(prevEtcvalues => ({
      ...prevEtcvalues,
      [complaintId]: etcValue
    }));

        // Update the database
        const response = await fetch(`${config.BASE_URL_IP}/wob/Technician-setETC/${complaintId}/${etcValue}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
      });
      console.log(response);

      let receiverId = complainerId;
      // Make a POST request to save the notification in the database
      await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ complaintId,receiverId, message: `Expected Date of Completion for your complaint ${complaintId} is set as ${etcValue}` })
    });
    //to give notification as email
    const to = email_id;// to complainer
    const subject = 'ETC set successfully';
        // to send notification as mail
        await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ to,subject , text:`Expected Date of Completion for your complaint ${complaintId} is set as ${etcValue}` })
    });
      setAlert({ open: true, message: 'ETC set successfully.', severity: 'success', variant:'filled' });

      window.location.reload();
  };
 
  const handleCloseTechnician = async (complaintId,complainerId,completionSummary,email_id) => {
    console.log(email_id);
    if (completionSummary.trim() === '') {
      setAlert({ open: true, message: 'Please enter a message.', severity: 'warning', variant:'filled' }); // Show alert if the message is empty
      return;
    }

  try {
      // If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
      setApprovalStatus(prevStatus => ({
          ...prevStatus,
          [complaintId]: "Closed"
      }));

      const receiverId = complainerId
      
      // Update the database
      const response = await fetch(`${config.BASE_URL_IP}/wob/Technician-Closecomplaint/${complaintId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ completionSummary })
      });

       // Make a POST request to save the notification in the database
       await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ complaintId,receiverId, message: `The technician has closed the complaint ${complaintId}.please review the completion summary and approve it` })
    });

      //to give notification as email
      const to = email_id;// to supervisor
      const subject = 'Work assiigned to Technician';
          // to send notification as mail
          await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ to,subject , text:`The technician has closed the complaint ${complaintId}.please review the completion summary and approve it` })
      });

      console.log(response);
      setAlert({ open: true, message: 'Complaint Closed Successfully.', severity: 'success', variant:'filled' });
      setTimeout(function(){window.location.reload()}, 2000);
    } catch (err) {
        console.log(err.message);
    }
  };

  const handleCloseSupervisor = async (complaintId,complainerId,completionSummary,email_id) => {
    if (completionSummary.trim() === '') {
      setAlert({ open: true, message: 'Please enter a message.', severity: 'warning', variant:'filled' });// Show alert if the message is empty
      return;
    }

    try {
        // If the approvedByHodDate doesn't exist, proceed with updating the approval status and database
        setApprovalStatus(prevStatus => ({
            ...prevStatus,
            [complaintId]: "Closed"
        }));
  
        const receiverId = complainerId
        
          await fetch(`${config.BASE_URL_IP}/wob/save-notification`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ complaintId,receiverId, message: `Your complaint ${complaintId}'s completion has been reviewed and approved by incharge. complaint officially closed` })
        });
        
        // Update the database
        const response = await fetch(`${config.BASE_URL_IP}/wob/Supervisor-Closecomplaint/${complaintId}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ completionSummary })
        });

      //to give notification as email
      const to = email_id;// to technician
      const subject = 'Completion summary approved by incharge';
          // to send notification as mail
          await fetch(`${config.BASE_URL_IP}/wob/send-email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ to,subject , text:`Your complaint ${complaintId}'s completion has been reviewed and approved by incharge. complaint officially closed` })
      });
              
        console.log(response);
        setAlert({ open: true, message: 'Complaint Closed Successfully.', severity: 'success', variant:'filled' });
        setTimeout(function(){window.location.reload()}, 2000);
      } catch (err) {
          console.log(err.message);
      }
    };

  const isApproved = (complaintId) => {
    return approvalStatus[complaintId] === "Approved";
  };

  const isApprovedAO = (complaintId) => {
    return approvalStatus[complaintId] === "Approved";
  };

  const isRejected = (complaintId) => {
    return approvalStatus[complaintId] === "Rejected";
  };

  const isCancelled = (complaintId) => {
    return approvalStatus[complaintId] === "Cancelled";
  };

  const isJustificationGiven = (complaintId) => {
    return approvalStatus[complaintId] === "Pending-justification given";
  };

  const isJustificationNeeded = (complaintId) => {
    return approvalStatus[complaintId] === "Pending-Justification needed";
  };

  const isClosed = (complaintId) => {
    return approvalStatus[complaintId] === "Closed";
  };

  useEffect(()=> {
      if (selectedValue === "Inprogress") {
        if(designation === 'Complainer')
          getInProgressComplaints();
        else if(designation === 'Head of department')
          getInProgressComplaintshod();
        else if(designation === 'Director')
          getInProgressComplaintsDirector();
        else if(designation === 'Supervisor')
          getInProgressComplaintsSupervisor();
        else if(designation === 'Technician')
          getInProgressComplaintstechnician();
        else if(designation === 'AO Officer')
          getInProgressComplaintsAOOfficer();
      } 
      else if (selectedValue === "Completed") {
        if(designation === 'Complainer')
          getCompletedComplaints();
        else if(designation === 'Head of department')
          getCompletedComplaintshod();
        else if(designation === 'Director')
          getCompletedComplaintsDirector();
        else if(designation === 'Supervisor')
          getCompletedComplaintsSupervisor();
        else if(designation === 'Technician')
          getCompletedComplaintstechnician();
        else if(designation === 'AO Officer')
          getCompletedComplaintsDirector();
      }
      else if (selectedValue === 'Rejected') {
        if (designation === 'Complainer')
          getRejectedComplaintsComplainer();
        else if (designation === 'Head of department')
          getRejectedComplaintsHod();
        else if (designation === 'Director')
          getRejectedComplaintsDirector();
        else if(designation === 'AO Officer')
          getRejectedComplaintsAOOfficer();
      }
      else if(selectedValue === 'RequireJustification'){
        if(designation === 'Complainer')
         getPendingComplaintsComplainer();
        else if(designation === 'Director')
          getPendingComplaintsDirector();

      }
      else if(selectedValue === "UnderProcurement"){
        // if(designation === 'Complainer')
        //   getUnderProcurementComplaintsComplainer();
        // else if(designation === 'Head of department')
        //   getUnderProcurementComplaintsHod();
        // else if(designation === 'Director')
        //   getUnderProcurementComplaintsDirector();
        if(designation === 'Supervisor')
          getUnderProcurementComplaintsSupervisor();
        else if(designation === 'Technician')
          getUnderProcurementComplaintsTechnician();
      }
      else if (selectedValue === "ToBeClosed") {
        if (designation === 'Supervisor')
          getToBeClosedComplaintsSupervisor();
      }
      else if (selectedValue === "ClosedByTechnician"){
        if (designation === 'Technician')
          getClosedByTechnicianComplaintsTechnician();
      }
  }, [selectedValue]);

  useEffect(()=> {
    getUserDetails();
     }, []);

  const toggleRow = (complaintId) => {
    setOpenRows(prevOpenRows => ({
      ...prevOpenRows,
      [complaintId]: !prevOpenRows[complaintId]
    }));
  };

  const handleRowClick = (complaintId) => {
    // Call the onRowClick function with the complaint ID when a row is clicked
    onRowClick(complaintId);
  };

  const [selectedOptions, setSelectedOptions] = useState(['Unattended by Technician', 'Complaint_Raised', 'inProgress', 'Under Procurement', 'Closed-technician']);

  const options = [
    { value: 'inProgress', label: 'inProgress' },
    { value: 'Complaint_Raised', label: 'Complaint_Raised' },
    { value: 'Unattended by Technician', label: 'Unattended by Technician' },
    { value: 'Under Procurement', label: 'Under Procurement' },
    { value: 'Closed-technician', label: 'Closed-technician' },
  ];

  const handleOptionChange = (value) => {
    setSelectedOptions((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((option) => option !== value)
        : [...prevSelected, value]
    );
  };

  useEffect(() => {
    console.log(selectedOptions);
    const newFilteredData = mainData.filter((data) =>
      selectedOptions.includes(data.work_status)
    );
    console.log(newFilteredData);
    setCombinedData(newFilteredData);
  }, [selectedOptions]);

  return (
    <div>
    {((designation === 'Head of department'|| designation === 'Complainer' || designation === 'Director' || designation === 'AO Officer' || designation === 'Supervisor' || designation === 'Technician') && selectedValue === 'Inprogress')&&  (
      console.log(designation),
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '600px', margin: '0' }}>
      <h3 style={{ color: '#333', margin: '10px'}}>Select Work Status to show</h3>
      <div style={{ display: 'flex', flexWrap: 'wrap', margin: '10px' }}>
        {options.map((option) => (
          <div key={option.value} style={{ marginRight: '16px' }}>
            <label>
              <input
                type="checkbox"
                value={option.value}
                // checked={true}
                checked={selectedOptions.includes(option.value)}
                onChange={() => handleOptionChange(option.value)}
              />
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
    )}
    <Table
      aria-label="simple table"
      sx={{
        mt: 3,
        whiteSpace: "nowrap",
      }}
    >
      <TableHead>
        {(selectedValue !== 'Completed')&&  (
         <>
        <TableRow>
          <TableCell>
            <Typography color="textSecondary" variant="h6">
             Work Status
            </Typography>
          </TableCell>
          {/* {(selectedValue === 'RequireJustification') && (
            <>
          <TableCell>
          </TableCell>
          </>
          )} */}
          <TableCell>
            <Typography color="textSecondary" variant="h6">
              WorkOrder Id
            </Typography>
          </TableCell>
          <TableCell>
            <Typography color="textSecondary" variant="h6">
              Work Order Raiser ID
            </Typography>
          </TableCell>
          <TableCell>
            <Typography color="textSecondary" variant="h6">
            Work Order Type
            </Typography>
          </TableCell>
          <TableCell>
            <Typography color="textSecondary" variant="h6">
            Work Order lodged
            </Typography>
          </TableCell>
          <TableCell></TableCell>
          <TableCell>
            <Typography color="textSecondary" variant="h6">
              View Work Order
            </Typography>
            </TableCell>
          {(designation === "Supervisor" && selectedValue === "Inprogress") && (
            <>
            <TableCell></TableCell>
            <TableCell>
              <Typography color="textSecondary" variant="h6">
              Assign Technician
              </Typography>
            </TableCell>
            </>
          )}
        </TableRow>
        </>
         )}
          {selectedValue === "Completed" && (
          <>
          <TableRow>
          <TableCell>
            <Typography color="textSecondary" variant="h6">
              Work Status
            </Typography>
          </TableCell> 
          
          <TableCell></TableCell>
          <TableCell>
            <Typography color="textSecondary" variant="h6">
              WorkOrder Id
            </Typography>
          </TableCell>
          <TableCell>
            <Typography color="textSecondary" variant="h6">
              Work Order Raiser ID
            </Typography>
          </TableCell>

          <TableCell>
            <Typography color="textSecondary" variant="h6">
            Work Order Type
            </Typography>
          </TableCell>

          <TableCell>
            <Typography color="textSecondary" variant="h6">
            Work Order lodged
            </Typography>
          </TableCell>

          <TableCell>
            <Typography color="textSecondary" variant="h6">
            Work Order rectified
            </Typography>
          </TableCell>  

          <TableCell>
            <Typography color="textSecondary" variant="h6">
              View Work Order
            </Typography>

          </TableCell>  

          
        </TableRow>
            </>
            )}
      </TableHead>
      <TableBody>
        {(selectedValue !== 'Completed') && combinedData.map(todo => {

          const correspondingTable1Data = combinedData.find(data => data.complaint_id === todo.complaint_id);
          const raisedDate = correspondingTable1Data ? new Date(correspondingTable1Data.complaint_raise_date) : null;
          const formattedRaisedDate = raisedDate ? raisedDate.toLocaleDateString() : '';

          return(
            <React.Fragment>
            <TableRow 

            key={todo.complaint_id} 
            onClick={() => {
              handleRowClick(todo.complaint_id);
            }} 
            sx={{
              "&:hover": { backgroundColor: "#f5f5f5" },
              backgroundColor: 
              !isApproved(todo.complaint_id) &&
              !isRejected(todo.complaint_id) &&
              !isJustificationNeeded(todo.complaint_id) &&
              designation === 'Director' &&
              (selectedValue === 'Inprogress' || selectedValue === 'RequireJustification')
                ? '#FFCC80' 
                : 'initial'
            }}
          >
            
            <TableCell>
            {(selectedValue === 'Inprogress') && (
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                  pl: "4px",
                  pr: "4px",
                  backgroundColor: "#1A97F5",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                {todo.work_status}
              </Typography>)}
              {(selectedValue === 'Rejected') && (
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                  pl: "4px",
                  pr: "4px",
                  backgroundColor: "#FC4B6C",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                {todo.work_status}
              </Typography>)}
              {(selectedValue === 'RequireJustification') && (
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                  pl: "4px",
                  pr: "4px",
                  backgroundColor: "#ffcc80",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                {todo.work_status}
              </Typography>)}
              {(selectedValue === 'UnderProcurement') && (
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: "500",
                    pl: "4px",
                    pr: "4px",
                    backgroundColor: "#FF9800",  
                    color: "#fff",        
                    borderRadius: "10px",
                  }}
                >
                  {todo.work_status}
                </Typography>
              )}
              {(selectedValue === 'ToBeClosed') && (
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: "500",
                    pl: "4px",
                    pr: "4px",
                    backgroundColor: "#8A2BE2",  // Violet color
                    color: "#fff",               // White text color
                    borderRadius: "10px",
                  }}
                >
                  {todo.work_status}
                </Typography>
              )}
              {(selectedValue === 'ClosedByTechnician') && (
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: "500",
                    pl: "4px",
                    pr: "4px",
                    backgroundColor: "#8A2BE2",  // Violet color
                    color: "#fff",               // White text color
                    borderRadius: "10px",
                  }}
                >
                  {todo.work_status}
                </Typography>
              )}
            </TableCell>
            {todo.work_status === 'Pending-justification given' && designation === 'Director' && (
              <TableCell>
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={() => toggleRow(todo.complaint_id)}
                >
                  {openRows[todo.complaint_id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </TableCell>
            )}
            {/* {((selectedValue === 'RequireJustification' || selectedValue === 'UnderProcurement')  && designation === 'Complainer') &&( */}
            {((selectedValue === 'RequireJustification')  && designation === 'Complainer') &&(
              <TableCell>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => toggleRow(todo.complaint_id)}
              >
                {openRows[todo.complaint_id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </TableCell>
            )}
            <TableCell>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                }}
              >
                {todo.complaint_id}
              </Typography>
            </TableCell>
            {/* <TableCell>
              <Typography color="textSecondary" variant="h6">
                {correspondingTable1Data.complaint_type}
              </Typography>
            </TableCell> */}
            <TableCell sx={{ maxWidth: "200px", wordWrap: "break-word", whiteSpace: "normal" }}>
  <Typography color="textSecondary" variant="h6">
    {correspondingTable1Data.complaint_type}
  </Typography>
</TableCell>
            <TableCell>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "600",
                    }}
                  >
                    {correspondingTable1Data.complainer_id}
                  </Typography>
                  <Typography
                    color="textSecondary"
                    sx={{
                      fontSize: "13px",
                    }}
                  >
                    {}
                  </Typography>
                </Box>
              </Box>
            </TableCell>
      <TableCell>
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: "500",
          }}
        >
          {formattedRaisedDate}
        </Typography>
      </TableCell>
                  <TableCell>
                  <Snackbar
                    open={alert.open}
                    autoHideDuration={6000}
                    onClose={handleCloseAlert}
                  >
                    <Alert onClose={handleCloseAlert} severity={alert.severity} variant={alert.variant}>
                      {alert.message}
                    </Alert>
                  </Snackbar>
      
                    {( selectedValue === 'Inprogress' && designation === 'Complainer' && todo.approved_by_hod_date === null && !isCancelled(todo.complaint_id)) && (
                      <Button variant="contained" color="error" style={{ padding: "5px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleCancelComplaint(todo.complaint_id,todo.email_id)}>Cancel</Button>
                    )}
      
                    {(!isApproved(todo.complaint_id) && !isRejected(todo.complaint_id) && designation === 'Head of department' && selectedValue === 'Inprogress') && (
                      <>
                        <Button variant="contained" color="success" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleOpenHOD(todo.complaint_id,todo.complainer_id,todo.email_id)}>Approve</Button>
                        <Button variant="contained" color="error" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleOpen(todo.complaint_id, todo.complainer_id,todo.email_id)}>Reject</Button>
                      </>
                    )}

                    {(!isApproved(todo.complaint_id) && !isRejected(todo.complaint_id) && designation === 'AO Officer' && selectedValue === 'Inprogress') && (
                       <>
                        <Button variant="contained" color="success" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleApproveAO(todo.complaint_id,todo.complainer_id,todo.email_id)}>Approve</Button>
                        <Button variant="contained" color="error" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleOpenAO(todo.complaint_id, todo.complainer_id,todo.email_id)}>Reject</Button>
                      </>
                    )}
      
                    {(!isApproved(todo.complaint_id) && !isRejected(todo.complaint_id) && !isJustificationNeeded(todo.complaint_id) && designation === 'Director'  && (selectedValue === 'Inprogress' || selectedValue === 'RequireJustification')) && (
                      <>
                        <Button variant="contained" color="success" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleApproveDirector(todo.complaint_id,todo.complainer_id,todo.email_id)}>Approve</Button>
                        <Button variant="contained" color="error" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleOpend(todo.complaint_id, todo.complainer_id,todo.email_id)}>Reject</Button>
                      </>
                    )}
      
                    {(!isApproved(todo.complaint_id) && !isRejected(todo.complaint_id) && designation === 'Supervisor' && selectedValue === 'ToBeClosed') && (
                      <>
                        <Button variant="contained" color="success" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleApproveSupervisorCompletionsummary(todo.complaint_id,todo.complainer_id,todo.email_id)}>Approve</Button>
                        <Button variant="contained" color="primary" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleOpencs(todo.complaint_id, todo.complainer_id, todo.email_id,todo.completion_summary)}>Edit</Button>
                      </>
                    )}
      
                    {(!isApproved(todo.complaint_id) && !isRejected(todo.complaint_id) && designation === 'Supervisor' && selectedValue === 'UnderProcurement') && (
                      <>
                        <Button variant="contained" color="success" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleReopen(todo.complaint_id,todo.complainer_id)}>Reopen Complaint</Button>
                      </>
                    )}
      
                    {(!isApproved(todo.complaint_id) && !isRejected(todo.complaint_id) && !isJustificationGiven(todo.complaint_id) && !isJustificationNeeded(todo.complaint_id) && designation === 'Director' && selectedValue === 'Inprogress')&&(
                      <>
                        <Button variant="contained" color="primary" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleJustificationDirector(todo.complaint_id,todo.complainer_id,todo.email_id)}>Give justification</Button>
                      </>
                    )}
      
                    {(!isClosed(todo.complaint_id) && todo.work_status !== 'Under Procurement' && todo.work_status !== 'Unattended by Technician' && etcValues[todo.complaint_id] !== undefined && designation === 'Technician' )&&(
                      <>
                        <Button variant="contained" color="error" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleOpenc(todo.complaint_id, todo.complainer_id,todo.email_id)}>Close</Button>
                      </>
                    )}
      
                    {(!isClosed(todo.complaint_id) && todo.work_status !== 'Under Procurement' && todo.work_status !== 'Unattended by Technician' && designation === 'Technician' )&&(
                      <>
                        <Button variant="contained" color="primary" style={{ padding: "10px", borderRadius: "10px", marginRight: "10px" }} onClick={() => handleUnderProcurement(todo.complaint_id, todo.complainer_id)}>Procurement Close</Button>
                      </>
                    )}
      
                    {/* {isApproved(todo.complaint_id) && <Button variant="contained" disabled>Approved</Button>}
                    {isRejected(todo.complaint_id) && <Button variant="contained" disabled>Rejected</Button>}
                    {isCancelled(todo.complaint_id) && <Button variant="contained" disabled>Cancelled</Button>}
                    {(isJustificationGiven(todo.complaint_id) || isJustificationNeeded(todo.complaint_id)) && <Button variant="contained" disabled>Give Justification</Button>}
                    {((isClosed(todo.complaint_id) && selectedValue === 'Inprogress') && etcValues[todo.complaint_id] === undefined ) && <Button variant="contained" disabled>Close</Button>} */}
                  </TableCell>
                <TableCell>
                <Overlayy complaint_id={todo.complaint_id}/>
                </TableCell>
              {(designation === 'Head of department') && (
                  <Modal open={openHOD} onClose={handleCloseHOD}
                  slotProps={{
                    backdrop: {
                        style: {
                            backgroundColor: 'rgba( 0,0,0,0.1)',
                        }
                    }
                }}>
                    <Box sx={{ ...style, width: 500}}>
                        <Typography variant="h6" component="h2">
                            Approval Comments
                        </Typography>
                        <TextField
                            label="Approval comments"
                            fullWidth
                            multiline
                            rows={9}
                            value={approvalComments}
                            onChange={(e) => setApprovalComments(e.target.value)}
                            variant="outlined"
                            margin="normal"
                        />
                        <Button variant="contained" color="primary" onClick={handleApproveWithCommentsHOD}>
                            Submit
                        </Button>
                    </Box>
                </Modal>
              )}
              {(designation === 'Head of department') && (
                <Modal open={open} onClose={handleClose}
                slotProps={{
                  backdrop: {
                      style: {
                          backgroundColor: 'rgba( 0,0,0,0.1)',
                      }
                  }
              }}>
                  <Box sx={{ ...style, width: 500}}>
                      <Typography variant="h6" component="h2">
                          Reject Complaint
                      </Typography>
                      <TextField
                          label="Rejection Summary"
                          fullWidth
                          multiline
                          rows={9}
                          value={rejectionSummary}
                          onChange={(e) => setRejectionSummary(e.target.value)}
                          variant="outlined"
                          margin="normal"
                      />
                      <Button variant="contained" color="primary" onClick={handleRejectWithSummaryHOD}>
                          Submit
                      </Button>
                  </Box>
              </Modal>
            )}
            {(designation === 'AO Officer') && (
                <Modal open={openAO} onClose={handleClose}
                slotProps={{
                  backdrop: {
                      style: {
                          backgroundColor: 'rgba( 0,0,0,0.1)',
                      }
                  }
              }}>
                  <Box sx={{ ...style, width: 500}}>
                      <Typography variant="h6" component="h2">
                          Reject Complaint
                      </Typography>
                      <TextField
                          label="Rejection Summary"
                          fullWidth
                          multiline
                          rows={9}
                          value={rejectionSummary}
                          onChange={(e) => setRejectionSummary(e.target.value)}
                          variant="outlined"
                          margin="normal"
                      />
                      <Button variant="contained" color="primary" onClick={handleRejectWithSummaryAO}>
                          Submit
                      </Button>
                  </Box>
              </Modal>
            )}
            {(designation === 'Director') && (
                <Modal open={opend} onClose={handleClosed}
                slotProps={{
                  backdrop: {
                      style: {
                          backgroundColor: 'rgba( 0,0,0,0.1)',
                      }
                  }
              }}>
                  <Box sx={{ ...style, width: 500}}>
                      <Typography variant="h6" component="h2">
                          Reject Complaint
                      </Typography>
                      <TextField
                          label="Rejection Summary"
                          fullWidth
                          multiline
                          rows={9}
                          value={rejectionSummary}
                          onChange={(e) => setRejectionSummary(e.target.value)}
                          variant="outlined"
                          margin="normal"
                      />
                      <Button variant="contained" color="primary" onClick={handleRejectWithSummaryDirector}>
                          Submit
                      </Button>
                  </Box>
              </Modal>
            )}
            {(designation === 'Technician') && (
                <Modal open={openc} onClose={handleClosec}
                slotProps={{
                  backdrop: {
                      style: {
                          backgroundColor: 'rgba( 0,0,0,0.1)',
                      }
                  }
              }}>
                  <Box sx={{ ...style, width: 500}}>
                      <Typography variant="h6" component="h2">
                          Work Completion summary
                      </Typography>
                      <TextField
                          label="Work completion summary"
                          fullWidth
                          multiline
                          rows={9}
                          value={completionSummary}
                          onChange={(e) => setCompletionSummary(e.target.value)}
                          variant="outlined"
                          margin="normal"
                      />
                      <Button variant="contained" color="primary" onClick={handleCompletionSummary}>
                          Submit
                      </Button>
                  </Box>
              </Modal>
            )}
            {(designation === 'Supervisor') && (
                <Modal open={opencs} onClose={handleClosecs}
                slotProps={{
                  backdrop: {
                      style: {
                          backgroundColor: 'rgba( 0,0,0,0.1)',
                      }
                  }
              }}>
                  <Box sx={{ ...style, width: 500}}>
                      <Typography variant="h6" component="h2">
                          Work Completion summary
                      </Typography>
                      <TextField
                          label="Work completion summary"
                          fullWidth
                          multiline
                          rows={9}
                          value={completionSummary}
                          onChange={(e) => setCompletionSummary(e.target.value)}
                          variant="outlined"
                          margin="normal"
                      />
                      <Button variant="contained" color="primary" onClick={handleCompletionSummarysupervisor}>
                          Submit
                      </Button>
                  </Box>
              </Modal>
            )}
            <TableCell>
              {(!isApproved(todo.complaint_id) && designation === 'Supervisor' && selectedValue === 'Inprogress')&&(
                <Select
                value={selected}
                placeholder="select"
                onChange={(e) => {
                  setSelectedValue(e.target.value);
                  handleApproveSupervisor(todo.complaint_id, e.target.value, todo.complainer_id, todo.email_id, todo.contact_num, e.target.key);
                }}
                displayEmpty
                style={{ marginRight: '10px' }}
              >
                <MenuItem value="" disabled>
                  <em>Select Technician</em>
                </MenuItem>
                {table3Data.map(
                  (user) =>
                    user.designation === "Technician" && user.department === department && (
                      <MenuItem key={user.email_id} value={user.user_id}>
                        {user.user_name}
                      </MenuItem>
                    )
                )}
              </Select>              
              )}
              {(isApproved(todo.complaint_id) && designation === 'Supervisor')&& <Button variant="contained" disabled>{todo.technician_id}</Button>}
            </TableCell>
            <TableCell
              style={{
                width: '150px',
                padding: '8px',
                borderRadius: '4px',
                backgroundColor: etcValues[todo.complaint_id] ? '#f0f0f0' : '#fff', // Change background color if value is selected
              }}  >
              {designation === 'Technician' && selectedValue === 'Inprogress' && todo.work_status === 'inProgress' && (
                <>
                  {etcValues[todo.complaint_id] === undefined ? (
                    <Select
                      label="ETC"
                      value={etcValues[todo.complaint_id] || ""}
                      onChange={(e) => handleETCChange(todo.complainer_id, todo.complaint_id, e.target.value,todo.email_id)}
                      style={{ width: '150px' }}
                    >
                      <MenuItem value="">Select ETC</MenuItem>
                      {Object.values(ETCOptions).map(option => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                      ))}
                    </Select>
                  ) : (
                    <>
                      <MenuItem value={etcValues[todo.complaint_id]} disabled>{etcValues[todo.complaint_id]}</MenuItem>
                    </>
                  )}
                </>
              )}
            </TableCell>
          </TableRow> 
          {(selectedValue === 'RequireJustification' && designation === 'Complainer') && (
            <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
              <Collapse in={openRows[todo.complaint_id]} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Table size="medium">
                    <TableHead>
                    <TableRow>
                    <TableCell>
                    <TextField
                          label="Justification"
                          fullWidth
                          multiline
                          rows={7}
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          variant="outlined"
                          margin="normal"
                      />
                      </TableCell>
                      <TableCell align="right">
                        <Button variant="contained" disabled={isSent[todo.complaint_id] || (combinedData.find(data => data.complaint_id === todo.complaint_id)?.justification !== null)
} color="primary" onClick={() => handleSend(todo.complaint_id,todo.complainer_id)}>Send</Button>
                        {/* <Snackbar
                          open={alert.open}
                          autoHideDuration={6000}
                          onClose={handleCloseAlert}
                        >
                          <Alert onClose={handleCloseAlert} severity={alert.severity}>
                            {alert.message}
                          </Alert>
                        </Snackbar> */}
                      </TableCell>
                    </TableRow>
                    </TableHead>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
            </TableRow>
            )}
            {todo.work_status === 'Pending-justification given' && designation === 'Director' && (
            <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
              <Collapse in={openRows[todo.complaint_id]} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Table size="medium">
                    <TableHead>
                    <TableRow>
                    <TableCell>
                    JUSTIFICATION: 
                        <Typography
                          sx={{
                            fontSize: "15px",
                            fontWeight: "500",
                          }}
                        >
                          {correspondingTable1Data.justification}
                        </Typography>
                    </TableCell>
                    </TableRow>
                    </TableHead>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
            </TableRow>
            )}
            {(selectedValue === 'Rejected' && designation === 'Complainer' && (correspondingTable1Data.work_status === 'Rejected By HOD' || correspondingTable1Data.work_status === 'Rejected By Director')) && (
                <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                  <Collapse in={openRows[todo.complaint_id]} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                      <Table size="medium">
                        <TableHead>
                          <TableRow>
                            <TableCell>Rejection Summary</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {combinedData.filter(historyRow => historyRow.complaint_id === todo.complaint_id)
                          .map(historyRow => {
                            const correspondingTable2Data = combinedData.find(data => data.complaint_id === historyRow.complaint_id);
                            return (
                              <TableRow >
                                <TableCell>
                                  <Box sx={{ maxWidth: 400, whiteSpace: 'pre-wrap' }}>
                                    <Typography variant="body2">{correspondingTable2Data.rejection_summary}</Typography>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </Box>
                  </Collapse>
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
          )
        })} 
          {selectedValue === "Completed" && combinedData.map(todo => {

          const correspondingTable1Data = combinedData.find(data => data.complaint_id === todo.complaint_id);
          const raisedDate = correspondingTable1Data ? new Date(correspondingTable1Data.complaint_raise_date) : null;
          const completedDate = correspondingTable1Data ? new Date(correspondingTable1Data.work_completion_date) : null;
          const formattedRaisedDate = raisedDate ? raisedDate.toLocaleDateString() : '';
          const formattedCompletedDate = completedDate ? completedDate.toLocaleDateString() : '';
          // const correspondingTable2Data = combinedData.table2Data.find(data => data.complaint_id === todo.complaint_id);
          // if (!correspondingTable2Data) {
          //   return null; // Skip rendering if there's no corresponding data in table2Data
          // }
          const workStatus = todo.work_status;
          return(
          <React.Fragment>
          <TableRow key={todo.complaint_id}
          onClick={() => {
            if (location.pathname === "/dashboard") {
              handleRowClick(todo.complaint_id);
             }
          }} 
          sx={{ "&:hover": { backgroundColor: "#f5f5f5" } }}>
          <TableCell>
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: "500",
                pl: "4px",
                pr: "4px",
                backgroundColor: 'success.main',
                color: "#fff",
                borderRadius: "10px",
              }}
            >
              {workStatus}
            </Typography>
          </TableCell>
            <TableCell>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => toggleRow(todo.complaint_id)}
              >
                {openRows[todo.complaint_id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </TableCell>
            <TableCell>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                }}
              >
                {todo.complaint_id}
              </Typography>
            </TableCell>
            <TableCell>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "600",
                    }}
                  >
                    {correspondingTable1Data.complainer_id}
                  </Typography>
                  {/* <Typography
                    color="textSecondary"
                    sx={{
                      fontSize: "13px",
                    }}
                  >
                    {}
                  </Typography> */}
                </Box>
              </Box>
            </TableCell>
            {/* <TableCell>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                }}
              >
                {correspondingTable1Data.title}
              </Typography>
            </TableCell> */}
            {/* <TableCell>
              <Typography color="textSecondary" variant="h6">
                {correspondingTable1Data.complaint_type}
              </Typography>
            </TableCell> */}
            <TableCell sx={{ maxWidth: "200px", wordWrap: "break-word", whiteSpace: "normal" }}>
  <Typography color="textSecondary" variant="h6">
    {correspondingTable1Data.complaint_type}
  </Typography>
</TableCell>

            <TableCell>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                }}
              >
                {formattedRaisedDate}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                }}
              >
                {formattedCompletedDate}
              </Typography>
            </TableCell>
            <TableCell>
            <Overlayy complaint_id={todo.complaint_id}/>
            </TableCell>
          </TableRow>
          {(selectedValue === 'Completed' && designation === 'Complainer' && todo.work_status === 'Completed-Without-Satisfaction-Points' && ((combinedData.find(data => data.complaint_id === todo.complaint_id)?.satisfaction_points === null))) && (
            <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
              <Collapse in={openRows[todo.complaint_id]} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Table size="medium">
                    <TableHead>
                    <TableRow>
                    <TableCell>
                    <TextField
                        label="Satisfactory Points"
                        fullWidth
                        multiline
                        rows={7}
                        value={satisfactionpoints}
                        onChange={(e) => setSatisfactionpoints(e.target.value)}
                        variant="outlined"
                        margin="normal"
                    />
                      </TableCell>
                      <TableCell align="right">
                        <Button variant="contained" disabled={isSentSatisfactorypoints[todo.complaint_id] || (combinedData.find(data => data.complaint_id === todo.complaint_id)?.satisfaction_points !== null)
} color="primary" onClick={() => handleSendSatifactorypoints(todo.complaint_id,todo.complainer_id,todo.technician_id,todo.email_id)}>Send</Button>
                      </TableCell>
                    </TableRow>
                    </TableHead>
                  </Table>
                </Box>
              </Collapse>
            </TableCell>
            </TableRow>
            )}
          <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={openRows[todo.complaint_id]} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="medium">
                  <TableHead>
                    <TableRow>
                    <TableCell style={{ fontWeight: 'bold', fontSize: '1.1em' }}>Completion summary</TableCell>
                    <TableCell style={{ fontWeight: 'bold', fontSize: '1.1em' }}>Satisfaction Points</TableCell>
                      {/* <TableCell>Rejection Summary</TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {combinedData.filter(historyRow => historyRow.complaint_id === todo.complaint_id)
                    .map(historyRow => {
                      const correspondingTable2Data = combinedData.find(data => data.complaint_id === historyRow.complaint_id);
                      return (
                        <TableRow >
                          <TableCell>
                            <Box sx={{ maxWidth: 400, whiteSpace: 'pre-wrap' }}>
                              <Typography variant="body2">{correspondingTable2Data.completion_summary}</Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ maxWidth: 400, whiteSpace: 'pre-wrap' }}>
                              <Typography variant="body2">{correspondingTable2Data.satisfaction_points}</Typography>
                            </Box>
                          </TableCell>
                          {/* <TableCell>
                            <Box sx={{ maxWidth: 400, whiteSpace: 'pre-wrap' }}>
                              <Typography variant="body2">{correspondingTable2Data.rejection_summary}</Typography>
                            </Box>
                          </TableCell> */}
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
          )
          })}
      </TableBody>
    </Table>
    </div>
  );
};

export default ComplaintsTable;


